import { createRoute } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import { HomeOverview } from "@/features/home/components/HomeOverview";
import { rootRoute } from "@/routes/root";

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/home",
  staticData: { title: "Home" },
  component: HomeOverview,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
});
